<div class="min-h-screen flex items-center justify-center bg-black bg-opacity-80">
  <div class="w-full max-w-md px-4">
    <!-- Card -->
    <div class="rounded-2xl border border-gray-800 bg-[#151515] px-5 py-8 text-white shadow-xl sm:px-8 sm:py-10">
      <!-- Logo -->
      <div class="flex justify-center mb-6">
        <img src="assets/brand/logo_branco.png" alt="ConectaOficina" class="h-12" />
      </div>

      <!-- Título -->
      <h1 class="text-center text-2xl font-semibold tracking-wide mb-6">
        CADASTRAR NOVA SENHA
      </h1>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <!-- Senha -->
        <div class="mb-4">
          <div class="relative">
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Nova senha"
                   class="w-full rounded-md bg-[#1f1f1f] border border-gray-600 px-3 py-2 text-sm text-white
                     placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500" />
            <button type="button" (click)="showPassword = !showPassword"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-300 hover:text-white">
              {{ showPassword ? 'Ocultar' : 'Mostrar' }}
            </button>
          </div>

          <p *ngIf="hasError('password', 'required')" class="mt-1 text-xs text-red-400">
            Informe a senha.
          </p>
          <p *ngIf="hasError('password', 'minlength')" class="mt-1 text-xs text-red-400">
            A senha deve ter pelo menos 6 caracteres.
          </p>
        </div>

        <!-- Confirmar senha -->
        <div class="mb-4">
          <div class="relative">
            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                   placeholder="Repetir senha" class="w-full rounded-md bg-[#1f1f1f] border border-gray-600 px-3 py-2 text-sm text-white
                     placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500" />
            <button type="button" (click)="showConfirmPassword = !showConfirmPassword"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-300 hover:text-white">
              {{ showConfirmPassword ? 'Ocultar' : 'Mostrar' }}
            </button>
          </div>

          <p *ngIf="hasError('confirmPassword', 'required')" class="mt-1 text-xs text-red-400">
            Confirme a senha.
          </p>
          <p *ngIf="hasError('confirmPassword', 'passwordMismatch')" class="mt-1 text-xs text-red-400">
            As senhas não conferem.
          </p>
        </div>

        <!-- Botão principal -->
        <button type="submit" [disabled]="resetPasswordForm.invalid"
                [style.opacity]="resetPasswordForm.invalid ? '0.6' : '1'" class="w-full mt-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-sm py-2.5 rounded-md
                 transition-colors disabled:cursor-not-allowed">
          Salvar nova senha
        </button>

        <!-- Link para login -->
        <p class="mt-6 text-center text-xs text-gray-300">
          Lembrou sua senha?
          <a routerLink="/auth/login" class="text-red-400 font-semibold hover:underline">
            Voltar para entrar
          </a>
        </p>
      </form>
    </div>

    <!-- Rodapé -->
    <p class="mt-4 text-center text-[11px] text-gray-400">
      © ConectaOficina – Todos os direitos reservados.
    </p>
  </div>
</div>